export default {
  links: {
    gdpr_file_url: 'https://app.uponline.ro/doc/ro/offers_gdpr.html',
    t_c_file_url: 'https://app.uponline.ro/doc/ro/offers_terms.html'
  }
}
